module.exports = __webpack_public_path__ + "static/03-2bbbf174731c2c1a141b317b9a6a9bc3.jpg";